module.exports = __webpack_public_path__ + "img/Desk Stationary A37.a682f251.jpg";